import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb, Table, Modal, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { Button } from 'primereact/button';
import config from '../../config';

import GifLoder from '../../components/GifLoder';


const Onboarding_Form = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true); // Initially true
    const [transition, setTransition] = useState(''); // Manage transition state
    
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 3000); // Set loading timeout to 3 seconds
    
        return () => clearTimeout(timer); // Cleanup on unmount
    }, []);

    const handleNavigation = (path, animationClass) => {
        setTransition(animationClass); // Set the animation class
        setTimeout(() => {
            navigate(path); // Navigate after animation
            setTransition(''); // Reset transition state
        }, 800); // Match the animation duration
    };


    if (loading) {
        return <div className="loderDiv">
            <GifLoder />
        </div>;
    }
    return (
        <>
            <Container fluid className="pt-lg-5 pt-5 px-lg-5 px-4">
                <Row className="pt-5 mb-3 d-flex justify-content-between align-items-center">
                    <div style={{width: '200px'}}>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Select Onboarding Type</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    
                    
                </Row>

                <Row className="pt-lg-5 mb-3 serviceCol">
                    <Col lg={12} md={12} className='mb-4 mb-lg-0 p-0'>
                        <div class="box-container  justify-content-center">
                            <div class="box-item">
                                <div class="flip-box">
                                    <div class="flip-box-front text-center gw-bgf">
                                        <div class="inner color-white" >
                                            <h3 class="flip-box-header">Weddings By Graphē</h3>
                                            {/*<p>Capture the magic of your special day with Graphē Wedding – where every moment is a masterpiece!</p>
                                             <img src="https://s25.postimg.cc/65hsttv9b/cta-arrow.png" alt="" class="flip-box-img"> 
                                            <Button
                                                label="Submit Now"
                                                icon="pi pi-arrow-right"
                                                className="py-2 text-white"
                                                outlined
                                                iconPos="right"
                                                onClick={() => handleNavigation('/Graphe/dashboard/Add_client_Onboarding/Wedding', 'slide-left')}
                                            />*/}
                                        </div>
                                    </div>
                                    <div class="flip-box-back text-center gw-bgf2">
                                        <div class="inner color-white">
                                            <h3 class="flip-box-header">Weddings By Graphē</h3>
                                            {/* <p>Capture the magic of your special day with Graphē Wedding – where every moment is a masterpiece!</p> */}
                                            <Button
                                                label="Submit Now"
                                                icon="pi pi-arrow-right"
                                                className="py-2 text-white"
                                                outlined
                                                iconPos="right"
                                                onClick={() => handleNavigation('/Graphe/dashboard/Add_client_Onboarding/Wedding', 'slide-left')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="box-item">
                                <div class="flip-box">
                                    <div class="flip-box-front text-center gw-bgf3">
                                        <div class="inner color-white">
                                            <h3 class="flip-box-header">Website / Mobile App</h3>
                                            {/* <p>Bring your ideas to life with stunning websites and mobile apps tailored just for you!</p>
                                            <Button
                                                label="Submit Now"
                                                icon="pi pi-arrow-right"
                                                className="py-2 text-white"
                                                outlined
                                                iconPos="right"
                                                onClick={() => handleNavigation('/Graphe/dashboard/Add_client_Onboarding/Development', 'slide-left')}
                                            /> */}
                                        </div>
                                    </div>
                                    <div class="flip-box-back text-center gw-bgf4">
                                        <div class="inner color-white">
                                            <h3 class="flip-box-header">Website/Mobile App</h3>
                                            {/* <p>Bring your ideas to life with stunning websites and mobile apps tailored just for you!</p> */}
                                            <Button
                                                label="Submit Now"
                                                icon="pi pi-arrow-right"
                                                className="py-2 text-white"
                                                outlined
                                                iconPos="right"
                                                onClick={() => handleNavigation('/Graphe/dashboard/Add_client_Onboarding/Development', 'slide-left')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="box-item">
                                <div class="flip-box">
                                    <div class="flip-box-front text-center gw-bgf5">
                                        <div class="inner color-white">
                                            <h3 class="flip-box-header">Marketing</h3>
                                            {/* <p>Unlock your brand’s potential with cutting-edge marketing strategies that make an impact!</p>
                                            <Button
                                                label="Submit Now"
                                                icon="pi pi-arrow-right"
                                                className="py-2 text-white"
                                                outlined
                                                iconPos="right"
                                                onClick={() => handleNavigation('/Graphe/dashboard/Add_client_Onboarding/Marketing', 'slide-left')}
                                            /> */}
                                        </div>
                                    </div>
                                    <div class="flip-box-back text-center gw-bgf6">
                                        <div class="inner color-white">
                                            <h3 class="flip-box-header">Marketing</h3>
                                            {/* <p>Unlock your brand’s potential with cutting-edge marketing strategies that make an impact!</p> */}
                                            <Button
                                                label="Submit Now"
                                                icon="pi pi-arrow-right"
                                                className="py-2 text-white"
                                                outlined
                                                iconPos="right"
                                                onClick={() => handleNavigation('/Graphe/dashboard/Add_client_Onboarding/Marketing', 'slide-left')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
 <div class="box-item">
                                <div class="flip-box">
                                    <div class="flip-box-front text-center gw-bgf7">
                                        <div class="inner color-white">
                                            <h3 class="flip-box-header">Branding</h3>
                                            {/* <p>Build a bold, memorable brand that stands out in every market</p>
                                            <Button
                                                label="Submit Now"
                                                icon="pi pi-arrow-right"
                                                className="py-2 text-white"
                                                outlined
                                                iconPos="right"
                                                onClick={() => handleNavigation('/Graphe/dashboard/Add_client_Onboarding/Branding', 'slide-left')}
                                            /> */}
                                        </div>
                                    </div>
                                    <div class="flip-box-back text-center gw-bgf8">
                                        <div class="inner color-white">
                                            <h3 class="flip-box-header">Branding</h3>
                                            {/* <p>Build a bold, memorable brand that stands out in every market</p> */}
                                            <Button
                                                label="Submit Now"
                                                icon="pi pi-arrow-right"
                                                className="py-2 text-white"
                                                outlined
                                                iconPos="right"
                                                onClick={() => handleNavigation('/Graphe/dashboard/Add_client_Onboarding/Branding', 'slide-left')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className={`transition-overlay ${transition}`} />
            </Container>
        </>
    );
}

export default Onboarding_Form;
